import CampusStipendBrochure from "./CampusStipendBrochure"

export default function CampusBrochureSRM() {
    return <CampusStipendBrochure college="SRM Chennai" eligibility="2nd or 3rd-year undergrad" campus="srm" />
}
